<template>
  <tr>
    <td>
      <div class="webhook--link">
        {{ webhook.url }}
        <div v-if="webhook.failed" class="badge--icon-warning">
          <fluent-icon
            v-tooltip.top-end="
              $t('INTEGRATION_SETTINGS.WEBHOOK.STATUS_FAILED_TOOLTIP')
            "
            class="inbox-icon"
            icon="warning"
            size="24"
            type="solid"
          />
        </div>
      </div>
      <span class="webhook--subscribed-events">
        <span class="webhook--subscribed-label">
          {{ $t('INTEGRATION_SETTINGS.WEBHOOK.SUBSCRIBED_EVENTS') }}:
        </span>
        <show-more :text="subscribedEvents" :limit="60" />
      </span>
    </td>
    <td>
      <woot-switch
        :value="webhook.active"
        @input="$emit('toggle', webhook, webhook.active)"
      />
    </td>
    <td class="button-wrapper">
      <woot-button
        v-tooltip.top="$t('INTEGRATION_SETTINGS.WEBHOOK.EDIT.BUTTON_TEXT')"
        variant="smooth"
        size="tiny"
        color-scheme="secondary"
        icon="edit"
        @click="$emit('edit', webhook)"
      />
      <woot-button
        v-tooltip.top="$t('INTEGRATION_SETTINGS.WEBHOOK.DELETE.BUTTON_TEXT')"
        variant="smooth"
        color-scheme="alert"
        size="tiny"
        icon="dismiss-circle"
        @click="$emit('delete', webhook, index)"
      />
    </td>
  </tr>
</template>
<script>
import webhookMixin from './webhookMixin';
import ShowMore from 'dashboard/components/widgets/ShowMore';

export default {
  components: { ShowMore },
  mixins: [webhookMixin],
  props: {
    webhook: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  computed: {
    subscribedEvents() {
      const { subscriptions } = this.webhook;
      return subscriptions.map(event => this.getEventLabel(event)).join(', ');
    },
  },
};
</script>
<style scoped lang="scss">
.webhook--link {
  display: flex;
  color: var(--s-700);
  font-weight: var(--font-weight-medium);
  word-break: break-word;
}

.webhook--subscribed-events {
  color: var(--s-500);
  font-size: var(--font-size-mini);
}

.webhook--subscribed-label {
  font-weight: var(--font-weight-medium);
}

.button-wrapper {
  max-width: var(--space-mega);
  min-width: auto;

  button:nth-child(2) {
    margin-left: var(--space-normal);
  }
}

.badge--icon-warning {
  display: block;
  width: var(--space-medium);
  height: var(--space-medium);
  margin-left: var(--space-smaller);
  padding: var(--space-smaller-plus);
  background: var(--conversa2-red-100-color);
  color: var(--conversa2-orange-900-color);
  border-radius: var(--border-radius-normal-small);
}
</style>
